import React from 'react';
import { useDispatch } from 'react-redux';
import { editQuestionnaireTitle } from '../../../../../../../_actions/questionnaire.actions';

export default function CancelEdit() {
  const dispatch = useDispatch();

  return <button onClick={() => {
    dispatch(editQuestionnaireTitle());
  }} type="button" className="btn btn-secondary btn-block">Close Properties</button>
}